import { WelcomeText } from './components/welcomeText';
import { useDisplayStore, useModeStore } from '../../../../store/sceneStore';

export function DefaultModeWidget() {
	const { data: display, setState: setDisplay } = useDisplayStore((s) => s);
	const mode = useModeStore();

	const onClickDisplayHide = () => {
		setDisplay({ ...display, mode: false });
	};

	const onClickDisplayShow = () => {
		setDisplay({ ...display, mode: true });
	};

	return (
		<>
			<div
				className={`displaybutton ${display.mode || (mode.ready && mode.run) ? '' : 'Show'}`}
			>
				<button
					type='button'
					className='Button'
					style={{ backgroundColor: 'rgba(0,0,0,0)' }}
					onClick={onClickDisplayShow}
					disabled={false}
				>
					<i className='mdi mdi-36px mdi-car-connected'></i>
					<br></br>
				</button>
			</div>
			<button
				type='button'
				className='Button'
				style={{ backgroundColor: 'rgba(0,0,0,0)' }}
				onClick={onClickDisplayHide}
				disabled={false}
			>
				<i className='mdi mdi-36px mdi-flip-v mdi-exit-to-app'></i>
				<br></br>
			</button>
			<WelcomeText />
		</>
	);
}
